import React, { useState} from 'react';
import '../../styles/mainContents.css';
import { setRotateRequestState } from '../../redux/actions/PostActions';
import { connect } from 'react-redux';
import Select from 'react-select';

function RotateRequestTable(props) {
                           
  const { rotateRequestPartnoListState, custid, custloc, rotateRequestState, dispatchSetRotateRequestState } = props; 

  return (

    <div>

      <table id='rotateRequestTblId'>
        <thead>
          <tr>  
            <th style={ {minWidth:'180px'}} >Partno</th>
            <th>Voltage</th>
            <th>Date Code</th>
            <th></th>
          </tr>
        </thead>
        { 
          <tbody id='rotateRequestDataTable_body'>
            {  
            rotateRequestState.map( (v, i) => (
              <tr   key={'rotateRequestTr-'+ ( (v['ID'] === undefined) ? 0 : v['ID'] )}>   
              {/* {console.log('RotatesRequestTable i', i, 'v',v, "v['ID']",v['ID'])} */}
                <td>
                  <Select menuPosition="fixed" menuPlacement="top" 
                  options={ rotateRequestPartnoListState } 
                  onChange={ (e) => { 
                    
                    // e.value =  e.value.trim().toUpperCase()
                    let currentValue = e.value
                    // console.log('RotatesRequestTable pt currentValue', currentValue, 'i', i, 'lastRowPartnoValue', currentValue)

                    if (currentValue !==  '') {     
                      
                      let maxPartnoLength = 53
                      if(currentValue.length > maxPartnoLength){
                        e.target.value = currentValue.substring(0,maxPartnoLength)
                        console.log('RotatesRequestTable: Partno length is invalid. Had entered ', currentValue.length, ' characters')
                        alert('Partno length is invalid. Please check partno.')
                      }
                      else{
                        try{
                          const param = {'PARTNO': currentValue, 'CUSTLOC': custloc }
                          // console.log('RotatesRequestTable pt param ', param, ' i ', i)

                          let rotateRequestNewItemState = null
                          let updatedRotateRequestState = null

                          updatedRotateRequestState = rotateRequestState.map((item, index) => {
                            if (index === i) {
                              return {
                                ...item,
                                ID: ((v['ID'] === undefined) ? 0 : v['ID']), 
                                PARTNO: currentValue,
                                CUSTID: custid,
                              };
                            }
                            return item;                                        
                          });
                       
                          if(!(i in rotateRequestState) || (i === rotateRequestState.length - 1) ){
                            rotateRequestNewItemState = {'ID': Math.floor(Math.random()*50000), 'PARTNO': '', 'VOLTAGE':'', 'DATECODE': '', 'CUSTID': custid}
                          }

                          let newState = [...updatedRotateRequestState]
                          if(rotateRequestNewItemState !== null){
                            newState = [...updatedRotateRequestState, rotateRequestNewItemState]
                          }
                          dispatchSetRotateRequestState(newState);                        

                        }
                        catch(ex){
                          console.log('ERROR RotatesRequestTable fetch_validateRotatesPartno failed : ' + ex)
                          alert('Unable to confirm partno. Please check and try again.')
                        }
                      }                        
                    }                       
                  
                  }}/>

                </td>  

                <td>
                  <input 
                    id={'iRotateVoltage-' + ((v['ID'] === undefined) ? 0 : v['ID']) }
                    className={'userInputField'}
                    type='number' 
                    name='nRotateRequestVoltage' 
                    onBlur={(e) => {                      
                      const updatedRotateRequestState = rotateRequestState.map((item, index) => {
                        if (index === i) {
                          return {
                            ...item,
                            VOLTAGE: e.target.value.trim(),
                          };
                        }
                        return item;
                      });
                      dispatchSetRotateRequestState(updatedRotateRequestState);

                    }
                    }
                  />                      
                </td>  

                <td>
                  <input 
                    id={'iRotateDateCode-' + ((v['ID'] === undefined) ? 0 : v['ID']) }
                    className={'userInputField'}
                    type='text' 
                    name='nRotateRequestDateCode' 
                    defaultValue={''}                   
                    onBlur={(e) => {                
                      const updatedRotateRequestState = rotateRequestState.map((item, index) => {
                        if (index === i) {
                          return {
                            ...item,
                            DATECODE: e.target.value.trim(),
                          };
                        }
                        return item;
                      });
                      dispatchSetRotateRequestState(updatedRotateRequestState);
                    }
                    }
                  />                      
                </td>   

                <td>
                  <input 
                    id={'iRotateDeleteRow-' + ((v['ID'] === undefined) ? 0 : v['ID']) }
                    className={'userInputField'}
                    type='button' 
                    name='nRotateRequestDeleteRow' 
                    defaultValue={'X'}     
                               
                    onClick={(e) => {
                      console.log('iRotateDeleteRow delete row clicked index:', i)

                      if(rotateRequestState.length > 1){
                        //delete row
                        console.log('RotatesRequestTable delete row rotateRequestState WAS', rotateRequestState, 'i',i)    

                        const updatedRotateRequestState = rotateRequestState.filter((item, index) => index !== i);

                        console.log('RotatesRequestTable delete row updatedRotateRequestState', updatedRotateRequestState, 'i',i)    

                        dispatchSetRotateRequestState(updatedRotateRequestState);                        
                      }
                      else {
                        const updatedRotateRequestState = rotateRequestState.map((item, index) => {
                          if (index === i) {
                            return {
                              ID: 0,
                              PRDID: '',
                              VOLTAGE: '',
                              DATECODE: '',
                              CUSTID: custid,
                            };
                          }
                          return item;
                        });
                        console.log('RotatesRequestTable delete row 0 updatedRotateRequestState', updatedRotateRequestState, 'i',i)    

                        dispatchSetRotateRequestState(updatedRotateRequestState);
                      }
                    }
                    }
                  />                      
                </td>                                                              
              </tr>               
             
              
       
            ))
            }

          </tbody>
        }

      </table>
    </div>

  );
}



const mapStateToProps = (state) => {
 return {
  authreducerState: state.authreducer,
  rotateRequestState: state.rotatesReducer['items_rotateRequestState'],
  rotateRequestPartnoListState: state.rotatesReducer['items_rotateRequestPartnoList'],

  
 }
};

const mapDispatchToProps = (dispatch) => {
  return {      
    dispatchSetRotateRequestState: (rotateRequestData) => {
      dispatch(setRotateRequestState(rotateRequestData));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RotateRequestTable);